var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_c('Loader')],1):_c('div',[(_vm.saving)?_c('Loader',{attrs:{"soft":true}}):_vm._e(),_c('div',{staticClass:"content"},[_c('Table',{ref:"table",attrs:{"columns":_vm.columns,"rows":_vm.list,"filters":_vm.filters,"totalRecords":_vm.list.length,"perpage":50}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }